import { AnalyticsEvents, EventConfig } from 'app/shared/u21-ui/analytics';
import { U21SectionProps } from 'app/shared/u21-ui/components';

export const getSectionName = (props: U21SectionProps): string => {
  const { 'aria-label': ariaLabel, title } = props;
  if (ariaLabel) {
    return ariaLabel;
  }
  if (typeof title === 'string') {
    return title;
  }
  return '';
};

export const expand: EventConfig = {
  name: 'Section Expanded',
  createPayload: (props: U21SectionProps) => {
    const name = getSectionName(props);
    if (!name) {
      return null;
    }
    return { name };
  },
};

export const collapse: EventConfig = {
  name: 'Section Collapsed',
  createPayload: (props: U21SectionProps) => {
    const name = getSectionName(props);
    if (!name) {
      return null;
    }
    return { name };
  },
};

export const u21SectionEvents = {
  [AnalyticsEvents.U21SECTION_ON_EXPAND]: expand,
  [AnalyticsEvents.U21SECTION_ON_COLLAPSE]: collapse,
};
